export default __webpack_public_path__ + "static/media/logoZephirWhite.3b0329b3.svg";